import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { AppContactIndexModel } from 'walden-fast/routes/app/contact';
import type { SortDirection } from 'walden-fast/types/pagination';

export default class AppContactIndexController extends Controller {
  declare model: AppContactIndexModel;

  queryParams = ['page', 'pageSize', 'sortField', 'sortDirection'];

  @tracked
  page = 1;

  @tracked
  pageSize = 10;

  @tracked
  sortField = '';

  @tracked
  sortDirection: SortDirection = 'none';

  @action
  sort(field: string, direction: SortDirection) {
    this.sortField = field;
    this.sortDirection = direction;
  }

  sortDirectionForField = (field: string) => {
    return this.sortField === field ? this.sortDirection : 'none';
  };
}
